import React, { useState, useEffect } from 'react';
import './LoginPage.css';

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [shake, setShake] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [success, setSuccess] = useState(false);
  const [sparkles, setSparkles] = useState([]);

  useEffect(() => {
    setTimeout(() => setLoaded(true), 150);
    setSparkles(Array.from({ length: 25 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 5,
      duration: 5 + Math.random() * 8,
      size: 10 + Math.random() * 30,
    })));
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    if (username.toLowerCase().trim() === 'pillu' && password.toLowerCase().trim() === 'iloveyou') {
      setSuccess(true);
      setError('');
      setTimeout(() => onLogin(), 1000); // 1 second smooth transition before unmounting
    } else {
      setError('Hmm… try again, my beautiful love 💙');
      setShake(true);
      setTimeout(() => setShake(false), 600);
    }
  };

  return (
    <div className={`login-bg ${success ? 'login-bg--success' : ''}`}>
      {/* Floating Sparkles */}
      {sparkles.map(s => (
        <div key={s.id} className="sparkle" style={{
          left: `${s.left}%`,
          width: s.size, height: s.size,
          animationDelay: `${s.delay}s`,
          animationDuration: `${s.duration}s`,
        }} />
      ))}

      <div className={`login-card ${loaded ? 'login-card--visible' : ''} ${shake ? 'login-card--shake' : ''} ${success ? 'login-card--fading-out' : ''}`}>

        <div className="login-badge">
          <span>✨</span>
        </div>

        <h1 className="login-title">A Gift For You</h1>
        <p className="login-subtitle">Unlock your birthday surprise</p>

        <form onSubmit={handleLogin} className="login-form">
          <div className="input-group">
            <label>Who is this for?</label>
            <input
              type="text"
              value={username}
              onChange={e => { setUsername(e.target.value); setError(''); }}
              placeholder="Your special name..."
              autoComplete="off"
            />
          </div>
          <div className="input-group">
            <label>The Secret Phrase</label>
            <input
              type="password"
              value={password}
              onChange={e => { setPassword(e.target.value); setError(''); }}
              placeholder="What do I always tell you?..."
            />
          </div>

          {error && <p className="login-error">{error}</p>}

          <button type="submit" className="login-btn">
            {success ? 'Opening...' : 'Open Gift'} <span className="btn-arrow">→</span>
          </button>
        </form>

        {/* <p className="login-hint">
          Hint: <em>Princess</em> &amp; <em>iloveyou</em> 💙
        </p> */}
      </div>
    </div>
  );
}
